import React from 'react'
import { Link } from 'react-router-dom'
import visa from "../assets/Images/visa.png"
import bhim from "../assets/Images/bhim.png"
import ae_1 from "../assets/Images/ae_1.png"
import paypal from "../assets/Images/paypal.png"
import mc_1 from "../assets/Images/mc_1.png"
import rupay from "../assets/Images/rupay.png"

const AddressHelp = () => {
  return (
    <div>
       <div className="address__help-row">
        <div className="address__payment-row">
          <img src={visa} alt="Visa Image" className="address__visa-icon" />
          <img src={rupay} alt="Rupay Image" className="address__visa-icon" />
          <img src={ae_1} alt="American Express Image" className="address__visa-icon" />
          <img src={mc_1} alt="Mastercard Image" className="address__visa-icon" />
          <img src={paypal}alt="Paypal Image" className="address__visa-icon" />
          <img src={bhim} alt="Bhim Image" className="address__visa-icon" />
        </div>
        <Link to="/About" className="address__help-text ui text size-text3xl">
          Need Help ? Contact Us
        </Link>
      </div>
    </div>
  )
}

export default AddressHelp
